const imageSettingsViewports = {
    searchResultContainer: {
        xs: { w: 214, h: 214 },
        sm: { w: 214, h: 214 },
        md: { w: 214, h: 214 },
        lg: { w: 214, h: 214 },
        xl: { w: 214, h: 214 }
    },
    quickView: {
        xs: { w: 200, h: 200 },
        sm: { w: 200, h: 200 },
        md: { w: 200, h: 200 },
        lg: { w: 200, h: 200 },
        xl: { w: 200, h: 200 }
    },
    cartLineItemComponent: {
        xs: { w: 74, h: 74 },
        sm: { w: 74, h: 74 },
        md: { w: 74, h: 74 },
        lg: { w: 74, h: 74 },
        xl: { w: 74, h: 74 }
    },
    pdpSlider: {
        xs: { w: 505, h: 505 },
        sm: { w: 505, h: 505 },
        md: { w: 505, h: 505 },
        lg: { w: 505, h: 505 },
        xl: { w: 505, h: 505 }
    },
    pdpSliderThumb: {
        xs: { w: 66, h: 66 },
        sm: { w: 66, h: 66 },
        md: { w: 66, h: 66 },
        lg: { w: 66, h: 66 },
        xl: { w: 66, h: 66 }
    },
    shopByCategory: {
        xs: { w: 98, h: 98 },
        sm: { w: 98, h: 98 },
        md: { w: 98, h: 98 },
        lg: { w: 98, h: 98 },
        xl: { w: 98, h: 98 }
    },
    productCollection: {
        xs: { w: 214, h: 214 },
        sm: { w: 214, h: 214 },
        md: { w: 214, h: 214 },
        lg: { w: 214, h: 214 },
        xl: { w: 214, h: 214 }
    },
    search: {
        xs: { w: 92, h: 92 },
        sm: { w: 92, h: 92 },
        md: { w: 92, h: 92 },
        lg: { w: 92, h: 92 },
        xl: { w: 92, h: 92 }
    },
    navigationMenu: {
        xs: { w: 292, h: 292 },
        sm: { w: 292, h: 292 },
        md: { w: 292, h: 292 },
        lg: { w: 292, h: 292 },
        xl: { w: 292, h: 292 }
    }
};
export default imageSettingsViewports;
